import React from 'react';
import { useIntl } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import classNames from 'classnames';
import './index.scss';

export default function SourceExplanation(props: any) {
  const {
    handleClickSourceState,
    openSource,
    textValue = 'dbi_pcconsole_source_differences_explanation',
    isNeedLeft = true,
  } = props;
  const { formatMessage } = useIntl();

  return (
    <span
      className="dbi-pcconsole-source-tips-btn"
      style={{ marginLeft: isNeedLeft ? 10 : 0 }}
      onClick={handleClickSourceState}
    >
      {formatMessage({ id: textValue })}
      <SvgIcon
        className={classNames('dbg-milestone-card-icon', {
          'dbi-pcconsole-source-tips-active': openSource,
        })}
        type="fill-icon-arrow"
      />
    </span>
  );
}
